<template>
    <div class="news">
      <div class="top">
        <div class="top__large">最新消息</div>
        <div class="top__small">Latest News</div>
      </div>
      <div class="content">
        <div class="title">最新消息</div>
        <div class="sub-title">Latest News</div>
  
        <div class="newsList">
          <ul>
            <li v-for="item in newsList" :key="item.id">
              <div class="newsBox" @click="newsDetail(item.url)">
                <img :src="item.picture" alt="" class="newsImg" />
                <div class="main">
                  <h2 class="news_title">{{ item.title }}</h2>
                  <span class="news_intro">{{ item.introduction }}</span>
                  <div class="main_footer">
                    <span class="news_type">{{
                      item.type == 1 ? "行业资讯" : "企业动态"
                    }}</span>
                    <span class="news_time">{{ item.editTime }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- <Page :total="totalPage" show-elevator /> -->
      </div>
    </div>
  </template>
  <script>
  import api from "../../api/api";
  import axios from "axios";
  export default {
    name: "new_News",
    data() {
      return {
        newsList: [
          {
            editTime: "2023-08-14 17:34",
            id: 86,
            introduction: "访问工程仿真（CAE）领域龙头企业，探索健康监测分析评估技术合作",
            picture: "https://yueq-static-1300597373.cos.ap-guangzhou.myqcloud.com/images/1.jpg",
            title: "访问工程仿真（CAE）领域龙头企业，探索健康监测分析评估技术合作",
            type: 0,
            url: "https://mp.weixin.qq.com/s/unkCuNbdmr49sSIDHE-slw"
          },
          {
            editTime: "2023-08-14 16:35",
            id: 85,
            introduction: "加强行业交流，促进产学研合作",
            picture: "https://yueq-static-1300597373.cos.ap-guangzhou.myqcloud.com/images/0.jpg",
            title: "加强行业交流，促进产学研合作",
            type: 0,
            url: "https://mp.weixin.qq.com/s/IIN_JwXgQZ8v0abiTBRigw"
          },
          {
            editTime: "2023-06-07 11:41:00",
            id: 84,
            introduction: "公司团建拓展活动",
            picture: "https://yueq-static-1300597373.cos.ap-guangzhou.myqcloud.com/images/10a5e730-a326-4375-bf2c-03d605ecece1.png",
            title: "公司团建拓展活动",
            type: 0,
            url: "https://mp.weixin.qq.com/s/BAI8KsmyErvqaipkYUAT4Q"
          },
          {
            editTime: "2023-06-02 11:15:43",
            id: 83,
            introduction: "第十三届南方计算力学学术会议（SCCM-13）成功举行",
            picture:
              "https://yueq-static-1300597373.cos.ap-guangzhou.myqcloud.com/images/10a5e730-a326-4375-bf2c-03d605ecece0.png",
            title: "第十三届南方计算力学学术会议（SCCM-13）",
            type: 1,
            url: "https://mp.weixin.qq.com/s/RclOfrqOy0w1lDbSp-grSw"
          },
          {
            editTime: "2023-03-31 17:06:00",
            id: 1,
            introduction: "广州粤桥工程咨询有限公司介绍",
            picture:
              "https://yueq-static-1300597373.cos.ap-guangzhou.myqcloud.com/images/companyProfile.jpg",
            title: "公司简介",
            type: 0,
            url: "https://mp.weixin.qq.com/s/V4wWapz63hPkySdFgJtYMg"
          }
        ],
        totalPage: 100
      };
    },
    created() {
      this.$emit("changeProduce", "new_News");
      // this.init();
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        axios({
          method: "get",
          url: api.Article
        })
          .then(res => {
            // console.log(res)
            if (res.data.code == 200) {
              let data = res.data.data;
  
              data.forEach(ele => {
                ele.time = new Date(ele.editTime).getTime();
              });
              data = data.sort((a, b) => b.time - a.time);
              this.newsList = data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      newsDetail(url) {
        window.open(url);
        // this.$router.push({path: '/news_detail', query: {url: url}})
      }
    }
  };
  </script>
  <style lang="less" scoped>
  .news {
    width: 100%;
    .top {
      width: 100%;
      height: 280px;
      background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/news_banner.png")
        center center no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      font-weight: bold;
      color: #fff;
      // padding-left: 210px;
      &__large {
        font-size: 40px;
        line-height: 1.5em;
        margin-left: 210px;
      }
      &__small {
        font-size: 26px;
        line-height: 1.2em;
        margin-left: 210px;
        word-spacing: 6px;
      }
    }
    .content {
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 0.8rem;//64px
      .title {
        margin: 0.6rem 0 0;//48px
        position: relative;
        font-size: 0.375rem;//30px
        line-height: 1.5em;
        font-weight: bold;
        color: #000;
      }
      .title::after {
        content: "";
        position: absolute;
        bottom: -0.1rem;//-8px
        left: 50%;
        transform: translateX(-50%);
        width: 2em;
        height: 0.1rem;//8px
        background-color: #2d8cf0;
      }
      .sub-title {
        margin: 0.125rem 0 0.4rem;//10 0 32
        font-size: 0.225rem;//18px
        line-height: 1.5em;
        color: #000;
      }
  
      .newsList {
        width: 80%;
        margin: 0 0 1.875rem;//150px
        ul {
          display: flex;
          flex-direction: column;
          padding: 0.2rem 0;//16px
          li {
            width: 100%;
            list-style: none;
            // height: 260px;
            padding: 0.125rem 0 0.375rem;//10 0 30
            margin: 0.125rem 0;//10
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
  
            .newsBox {
              width: 100%;
              margin: 0 auto;
              padding: 0 0 0.375rem;//30px
              border-bottom: 1px solid #000;
              display: flex;
              flex-direction: row;
              cursor: pointer;
              img {
                display: block;
                width: 3.75rem;//300px
                height: 2.5rem;//200px
              }
              .main {
                padding: 0 0.25rem;//20px
                position: relative;
                width: calc(100% - 4.25rem);//340px
                height: 2.5rem;
                .news_title {
                  font-size: 0.3rem;//24px
                  color: #000;
                  line-height: 1.5em;
                  height: 1.5em;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .news_intro {
                  position: relative;
                  padding: 0.125rem 0;//10px
                  display: block;
                  width: 100%;
                  font-size: 0.2rem;//16px
                  line-height: 1.5em;
                  height: 9em;
                  word-wrap: wrap;
                }
                .main_footer {
                  width: calc(100% - 0.2rem);//40px
                  height: 0.25rem;//20px
                  position: absolute;
                  bottom: 0;
                  display: flex;
                  justify-content: space-between;
                }
                .news_type,
                .news_time {
                  font-size: 0.175rem;//14px
                  line-height: 0.25rem;//20px
                }
              }
            }
          }
          li:hover {
            transition: all 0.3s;
            transform: scale(1.05);
          }
          li:hover .newsBox {
            box-shadow: 5px 5px 5px #ccc;
          }
        }
      }
    }
  }
  </style>
  